<template>
    <div class="buttons">
        <el-button class="whiteButton" @click="subtract">{{ buttonBeforeValue }}</el-button>
        <div class="right">
            <p v-if="!valid" class="valid">* fields are required</p>
            <el-button v-loading="loading" class="greenButton right" :disabled="disabled || loading" :style="{ background: getColor() }" @click="add">{{ buttonNextValue }}</el-button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            fields: []
        };
    },
    props:{
        loading: {
            type: Boolean,
            required: true
        },
        start: {
            type: Number,
            default(){
                return 0;
            }
        },
        disable: {
            type: Boolean,
            default(){
                return true;
            }
        },
        valid: {
            type: Boolean,
            default(){
                return false;
            }
        },
        end: {
            type: Number,
            default(){
                return 0;
            }
        },
        value: {
            type: Number,
            default(){
                return 0;
            }
        }
    },
    computed: {
        ...mapGetters([
            'getText'
        ]),
        disabled() {
            if (this.valid == true) {
                return false;
            }
            return true;
        },
        buttonNextValue() {
            if (this.value == this.end) {
                return this.getText('save_button');
            }
            return this.getText('motor_form_next_button');
        },
        buttonBeforeValue() {
            if (this.value > this.start) {
                return this.getText('motor_form_previous_button');
            }
            return this.getText('cancel_button');
        }
    },
    methods: {
        getColor() {
            if (this.valid == false) {
                return '#dee873 !important';
            }
            return '#c4d600 !important';
        },
        add() {
            let index = this.value + 1;
            if (index > this.end) {
                this.$emit('save', index);
                index = this.end;
            }
            this.$emit('input', index);
        },
        subtract() {
            let index = this.value - 1;
            if (index < this.start) {
                this.$emit('cancel', index);
                index = this.start;
            }
            this.$emit('input', index);
        }
    }
};

</script>

<style lang="less">
@import '../../../less/variables';

.right {
    float: right;
}

.valid {
    margin: -20px 0 0 5px;
    color: #f56c6c;
}

.buttons {
    width: 80%;
    margin: 10px auto 40px;
}

</style>


// WEBPACK FOOTER //
// src/components/partials/wizzard/Navigation.vue